import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BasicTextArea } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ClinicalStatusEditTemplate({ clinicalStatusEditViewStore }) {
    const {
        contentLoading,
        form,
    } = clinicalStatusEditViewStore;

    return (
        <ApplicationEditLayout store={clinicalStatusEditViewStore}>
            <Content loading={contentLoading} >
            <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicTextArea field={form.$('description')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>            </Content>
        </ApplicationEditLayout>
    )
}

ClinicalStatusEditTemplate.propTypes = {
    clinicalStatusEditViewStore: PropTypes.object
};

export default defaultTemplate(ClinicalStatusEditTemplate);
